import script from "./Button.vue?vue&type=script&lang=tsx"
export * from "./Button.vue?vue&type=script&lang=tsx"

import "./Button.vue?vue&type=style&index=0&id=20146f2e&lang=scss&scoped=true"

import exportComponent from "/builds/dc/siemens.fm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20146f2e"]])

export default __exports__